import { BASE_LAYERS, VIF_CONSTANTS } from '../constants';

export default {
  format: {
    type: 'visualization_interchange_format',
    version: VIF_CONSTANTS.LATEST_VERSION,
  },
  configuration: {
    baseLayerOpacity: 0.8,
    baseLayerUrl: BASE_LAYERS[0].legacyMapsTileUrlValue,
    datasetMetadata: false,
    locateUser: false,
    panAndZoom: true,
    rowInspectorTitleColumnName: null,
    viewSourceDataLink: true,
  },
  description: '',
  series: [
    {
      color: {
        primary: '#eb6900',
      },
      dataSource: {
        datasetUid: null,
        dimension: {
          columnName: null,
          aggregationFunction: null,
        },
        measure: {
          columnName: null,
          aggregationFunction: null,
        },
        type: 'socrata.soql',
        filters: [],
      },
      label: null,
      type: 'featureMap',
    },
  ],
  title: '',
};
